import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import Axios from "../axios";
import { useAuth } from "../auth/authContext";
import { useLocation } from "react-router-dom";
import { useClientReactQuill } from "../utils/reactQuillLoader";
import "react-quill/dist/quill.snow.css";

const TermsAndCondition = () => {
  const ReactQuill = useClientReactQuill();
  const { navData } = useAuth();
  const location = useLocation();
  const [description, setDescription] = useState("");
  const [id, setId] = useState("");
  const write = Boolean(
    navData.find((item) => item.link === location.pathname)?.write
  );

  useEffect(() => {
    fetchAllFaq();
  }, []);
  const fetchAllFaq = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-terms")
      .then((resp) => {
        setDescription(resp?.data?.data?.content);
        setId(resp?.data?.data?._id);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  const handleContentChange = (content) => {
    if (write) {
      setDescription(content);
    }
  };

  const handleSubmit = () => {
    const data = { content: description, id: id };
    Axios.post(process.env.REACT_APP_BACKEND + "create-terms", data)
      .then((resp) => {
        toast.success(
          resp?.data?.message || "Terms & Condition added successfully!"
        );
        setDescription(resp?.data?.data?.content);
        setId(resp?.data?.data?._id);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Failed to add Terms & Condition!"
        );
      });
  };
  return (
    <div>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <h2>Terms & Condition</h2>
      {ReactQuill ? (
        <ReactQuill
          theme="snow"
          value={description}
          onChange={handleContentChange}
          style={{ height: "650px", marginBottom: "20px" }} // Increased height
          modules={{
            toolbar: [
              [{ header: "1" }, { header: "2" }, { font: [] }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ align: [] }],
              ["bold", "italic", "underline", "strike"],
              [{ color: [] }, { background: [] }],
              [{ script: "sub" }, { script: "super" }],
              ["link", "image"],
              ["blockquote", "code-block"],
              ["clean"],
            ],
          }}
        />
      ) : (
        <div style={{ height: "650px", marginBottom: "20px" }} />
      )}
      {write ? (
        <Button
          className="w7 pd sevenly-btn text-white mt-5"
          onClick={handleSubmit}
          variant="contained"
          color="primary"
        >
          Add
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TermsAndCondition;
